import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { StyledCard } from './base/Card';
import Icon from './base/Icon';
import Text from './base/Text';
import CopyableField from './CopyableField';
import { Div } from './helpers/StyledUtils';
import { useCliLoginCommand } from '../hooks/useCliLoginCommand';
const CliLoginCommandCopyableField: React.FC = () => {
  const $ = _c(10);
  const {
    login_command,
    error,
    is_loading
  } = useCliLoginCommand();
  let t0;
  if ($[0] !== is_loading) {
    t0 = is_loading && <Div flex={{
      justify: "center",
      align: "center"
    }} p={3}><Icon icon="loading" muted={true} /></Div>;
    $[0] = is_loading;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== error) {
    t1 = error && <Text danger={true} p={3} size="s">Could not load a CLI login key. Check your connection and permissions, then refresh the page.</Text>;
    $[2] = error;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== login_command) {
    t2 = login_command && <Div data-testid="guided-cli-login-command"><CopyableField p={3} value={login_command} mono={true} borderless={true} variant="command_list" /></Div>;
    $[4] = login_command;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = <StyledCard overflow_hidden={true}>{t0}{t1}{t2}</StyledCard>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default CliLoginCommandCopyableField;